import React from 'react';
import ManageFreeTextEventMappingComponentVM from './ManageFreeTextEventMappingComponentVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageFreeTextEventMappingComponentProps {
    viewModel: ManageFreeTextEventMappingComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageFreeTextEventMappingComponent extends React.Component<IManageFreeTextEventMappingComponentProps> {
    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                {<Neo.Card title={viewModel.managedFreeTextMapping.rawGenericServiceProviderEventMappingId > 0 ? TextConstants.Titles.EditFreeTextEventMapping : TextConstants.Titles.AddFreeTextEventMapping}>
                    <div>
                        <Neo.Form model={viewModel.managedFreeTextMapping}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onInvalid={this.onFormInvalid}
                            onSubmit={() => this.props.onSave()}>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup bindContext={viewModel.managedFreeTextMapping.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                        bind={viewModel.managedFreeTextMapping.meta.staticServiceProviderFileGroupingId}
                                        bindDisplay={viewModel.managedFreeTextMapping.meta.serviceProviderGroupingName}
                                        displayMember={"serviceProviderGroupingName"}
                                        isReadOnly={viewModel.isFieldReadOnlyInd}
                                        items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                        />
                                </Neo.FormGroup>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.GenericSourceTable}
                                    bind={viewModel.managedFreeTextMapping.meta.destinationTableId}
                                    select={{ items: viewModel.destinationTablesList }}
                                    onChange={() => viewModel.clearDestinationField()} />
                                <Neo.FormGroup 
                                    bindContext={viewModel.managedFreeTextMapping.meta.sourceFieldName}
                                    label={TextConstants.Labels.SourceField}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={(searchValue) => viewModel.rawGenericMappingApiClient.getDestinationFieldListByCriteria(searchValue, viewModel.managedFreeTextMapping.meta.destinationTableId.value as number)}
                                        bind={viewModel.managedFreeTextMapping.meta.destinationFieldId}
                                        bindDisplay={viewModel.managedFreeTextMapping.meta.sourceFieldName}
                                        displayMember={"destinationFieldName"}
                                        isReadOnly={viewModel.managedFreeTextMapping.destinationTableId === 0}
                                        items={viewModel.rawGenericMappingApiClient.getDestinationFieldListByCriteria(" ", viewModel.managedFreeTextMapping.meta.destinationTableId.value as number).then((arr) => arr.data.slice(0,10)
                                        .sort((x,y) => x.destinationFieldName.localeCompare(y.destinationFieldName)))}
                                        />
                                </Neo.FormGroup>
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ValueIncludes}
                                    bind={viewModel.managedFreeTextMapping.meta.rawSourceFieldIncludes} />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ValueExcludes}
                                    bind={viewModel.managedFreeTextMapping.meta.rawSourceFieldExcludes} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.DestinationEventType}
                                    bind={viewModel.managedFreeTextMapping.meta.rawDestinationEventType} />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.DestinationCorporateActionType}
                                    bind={viewModel.managedFreeTextMapping.meta.rawDestinationCorporateActionType} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.PositiveValue}
                                    bind={viewModel.managedFreeTextMapping.meta.isPositiveValueInd}
                                    input={{ type: "switch" }} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={3}>
                                <NeoGrid.Grid items={viewModel.managedFreeTextMapping.rawGenericServiceProviderEventKeywords}
                                    addButton={{
                                        icon: "none",
                                        text: TextConstants.Buttons.AddKeyword,
                                    }}>
                                    {(item, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column bind={meta.keyword} />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </div>
                </Neo.Card>}
            </div>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidFreeTextEventMapping);
        }
    }
}